import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";

/**
 * GenerateChecklistServicoItensCadastroColumnDefinition
 */

type Props = {
  hasObraChecklistServico: boolean;
  onActionEditar: (idItemChecklistServico: number | null, openState: boolean) => void;
  onActionDeletar: (idItemChecklistServico: number | null, openState: boolean) => void;
};

export const GenerateChecklistServicoItensCadastroColumnDefinition = ({
  hasObraChecklistServico,
  onActionEditar,
  onActionDeletar,
}: Props): GridColDef[] => {
  return [
    {
      field: "ordem",
      filterable: false,
      headerName: "Ordem",
      minWidth: 100,
      sortable: false,
      headerClassName: 'funcionarios-header',
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex items-center text-xs py-2">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Item de inspeção",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: 'funcionarios-header',
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex items-center text-xs py-2">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "metodoVerificacao",
      filterable: false,
      headerName: "Método de Verificação",
      flex: 2,
      minWidth: 150,
      sortable: false,
      headerClassName: 'funcionarios-header',
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex items-center text-xs py-2">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "tolerancia",
      filterable: false,
      headerName: "Tolerância",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: 'funcionarios-header',
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex items-center text-xs py-2">
            {params.value}
          </div>
        );
      }
    },
    {
      field: "resumoItem",
      filterable: false,
      headerName: "Resumo",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: 'funcionarios-header',
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex items-center text-xs py-2">
            {params.value}
          </div>
        );
      }
    },
    {
      field: 'idItemChecklistServico',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 100,
      resizable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              onMouseDown={e => { onActionEditar(params.value, true) }}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            {
              !hasObraChecklistServico &&
              <IconButton
                disabled={hasObraChecklistServico}
                onClick={() => { onActionDeletar(params.value, true) }}>
                <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
              </IconButton>
            }

          </div>
        );
      }
    },
  ];
}